module.exports = __webpack_public_path__ + "img/calendar-clock.c42ca264.svg";